import React from 'react'
import { Form, Button, InputNumber, Input, Switch, Col } from 'antd'

const FormItem = Form.Item
const { TextArea } = Input

class ItemForm extends React.Component {
  constructor(props, context) {
    super(props, context)
    this.handleOnSubmit = this.handleOnSubmit.bind(this)
  }

  handleOnSubmit(e) {
    e.preventDefault()
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (err) {
        return
      }
      this.props.onSubmit(values)
    })
  }

  render() {
    const { getFieldDecorator } = this.props.form
    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 7 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 12 },
        md: { span: 8 },
      },
    }

    return (
      <Col {...formItemLayout.wrapperCol}>
        <Form onSubmit={this.handleOnSubmit} layout='inline' >
          <Form.Item label={this.props.formFieldValues.s_name} >
            {getFieldDecorator(`n_enable`, {
            valuePropName: 'checked',
            initialValue: this.props.formFieldValues.n_enable === '1',
            rules: [{ required: true, message: 'Пожалуйста укажите видимость кнопки.' }],
          })(<Switch
            loading={this.props.isEditButtonMenuItemLoading}
            onChange={e => this.props.onChange(this.props.formFieldValues.idnum, e, this.props.formFieldValues)}
          />)}
          </Form.Item>
        </Form>
      </Col>
    )
  }
}

const CustomizedForm = Form.create({
  onFieldsChange(props, changedFields) {
    props.onFieldsChange(changedFields)
  },
  // onValuesChange(_, values) {
  //   console.log(values)
  // },
})(ItemForm)

export default CustomizedForm



// WEBPACK FOOTER //
// src/containers/RoleForm/ButtonMenuForm.jsx